import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import {
  Datagrid,
  Filter,
  List,
  Loading,
  TextField,
  SelectInput,
  TextInput,
  FunctionField,
} from "react-admin";
import { ComponentProps } from "../../providers/Interfaces";

/* Filter not Working on API
const InsoleFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
  </Filter>
);
*/

export const InsoleOverviewList = (props: ComponentProps): JSX.Element => {
  const { permissions } = props;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (permissions !== undefined) {
      setLoading(false);
    }
  }, [permissions]);

  if (loading) return <Loading />;

  return (
    <List
      {...props}
      // filters={<InsoleFilter />}
      bulkActionButtons={false}
      sort={{ field: "id" }}
      title="Insoles"
    >
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="user" />
        <TextField source="created_at" />
      </Datagrid>
    </List>
  );
};
